module.exports = __webpack_public_path__ + "resources/img/img_passxpertv4_3_m.b28b5b4d1b65b26e2960beac20b6c0fd.png";